export const FEATURE_APR_NVL = 'apr-nvl';
export const FEATURE_PERFORMANCE_RATING = 'performance-rating';
export const FEATURE_BENCHMARKS = 'benchmarks';
export const FEATURE_AUR_NVL = 'aur-nvl';
